import { createSlice } from "@reduxjs/toolkit";

const loginSlice = createSlice({
  name: "adminLogin",
  initialState: {
    remindEmail: null,
  },
  reducers: {
    updateReminder: (state, action) => {
      state.remindEmail = action.payload;
    },
  },
});

export const { updateReminder } = loginSlice.actions;
export default loginSlice.reducer;
